// Shared react-query keys used across multiple pages. Centralized here
// so a page that mutates data can invalidate the same key another page
// reads from without creating cross-page imports.

export const DUPLICATES_COUNT_QUERY_KEY = ["duplicatesCount"] as const;
